import type { ReactNode } from "react";

type FinanceOnboardingCtaProps = {
  children: ReactNode;
  disabled?: boolean;
  onClick: () => void;
  type?: "button" | "submit";
};

export const FinanceOnboardingCta = ({
  children,
  disabled = false,
  onClick,
  type = "button",
}: FinanceOnboardingCtaProps) => (
  <button
    type={type}
    onClick={onClick}
    disabled={disabled}
    className="relative inline-flex h-14 w-[260px] items-center justify-center gap-3 overflow-hidden rounded-full px-7 text-base font-semibold text-white shadow-[0_10px_15px_-3px_rgba(47,110,218,0.28)] transition-all duration-200 hover:scale-[1.02] hover:shadow-[0_20px_25px_-5px_rgba(47,110,218,0.32)] disabled:cursor-not-allowed disabled:opacity-70 disabled:hover:scale-100"
    style={{
      background: "linear-gradient(135deg, rgb(67, 104, 229), rgb(47, 110, 218))",
    }}
  >
    <span className="relative z-10 inline-flex items-center justify-center gap-3">
      {children}
    </span>
    <span className="absolute inset-0 bg-white/20 skew-x-[-45deg] translate-x-[-100%] animate-shine" />
  </button>
);
